<!-- NotesApp Source File: home.component.html  -->

<app-global-dialog></app-global-dialog>
<alert></alert>
<div
  class="bg-surface-100 dark:bg-surface-950 min-h-screen p-0.5 flex flex-col home-root"
  [ngClass]="{ 'select-mode-active': isSelectMode, 'has-list-pager': showListPager }"
  [style.--home-bottom-stack-height.px]="bottomStackHeight"
  [style.--homeZoom]="homeZoomScale">
  <div class="home-zoom-layer">

    <app-header
      #header
      [projects]="projects"
      [tags]="filterTagCatalog"
      [privateTagFilterAvailable]="privateTagFilterAvailable"
      [spaces]="mySpaces"
      [statusValues]="statusValues"
      [isOnline]="connectivity.fullyOnline"
      [connectivityLabel]="connectivity.label"
      [types]="types"
      [isSelectMode]="isSelectMode"
      [selectedView]="selectedView"
      [externalFilter]="filter"
      [clearFilterTooltip]="clearFilterButtonTitle"
      [filterActive]="isFiltered"
      [mobileSearchFieldEl]="MobileSearchField"
      (headerMenuAction)="onPageMenuAction($event)"
      (searchChanged)="onSearchChanged($event)"
      (filterChanged)="onFilterChanged($event)"
      (sortRequested)="onSortRequested($event)">
    </app-header>

    <app-bulk-action-dialog
      [visible]="bulkDialogVisible"
      [action]="currentBulkAction"
      [statuses]="statusValues"
      [tags]="availableTags"
      [removableTags]="bulkRemovableTags"
      [moveDestinations]="bulkMoveDestinations"
      [addTagGroups]="bulkAddTagGroups"
      [removeTagGroups]="bulkRemoveTagGroups"
      [selectedCount]="selectedNoteIds.length"
      (cancel)="onBulkActionDialogCancel()"
      (submit)="onBulkActionDialogSubmit($event)">
    </app-bulk-action-dialog>

    <input
      #importJsonFileInput
      type="file"
      accept="application/json,.json"
      hidden
      (change)="onImportJsonFileSelected($event)" />
    <app-import-preview-dialog
      [visible]="importPreviewDialogVisible"
      [fileErrors]="importFileErrors"
      [rows]="importPreviewRows"
      (visibleChange)="importPreviewDialogVisible = $event"
      (cancel)="onImportPreviewCancel()"
      (confirm)="onImportPreviewConfirm($event)"
      (viewLog)="openImportLogDialog()">
    </app-import-preview-dialog>

    <p-dialog
      header="Import Log"
      [(visible)]="importLogDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: 'min(96vw, 44rem)' }"
      appendTo="body">
      <div *ngIf="!importLogEntries.length" class="text-sm text-surface-500">
        No import has been run yet in this session.
      </div>
      <div *ngIf="importLogEntries.length" class="max-h-[60vh] overflow-y-auto">
        <pre class="whitespace-pre-wrap break-words text-xs font-mono leading-relaxed">{{ importLogEntries.join('\n') }}</pre>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 w-full">
          <p-button
            *ngIf="importLogEntries.length"
            label="Clear"
            severity="secondary"
            (onClick)="importLogEntries = []">
          </p-button>
          <p-button label="Close" (onClick)="importLogDialogVisible = false"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      header="App Info"
      [(visible)]="appInfoDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '32rem', maxWidth: '92vw' }"
      appendTo="body">
      <div class="space-y-3 text-sm">
        <div class="space-y-2">
          <div class="flex items-center gap-2 flex-wrap">
            <strong>Environment:</strong>
            <app-env-badges />
          </div>
          <div><strong>Client:</strong> {{ envInfo.client }} build (v{{ envInfo.clientVersion }}) served from {{ envInfo.host }}</div>
          <div><strong>Database:</strong> {{ envInfo.database }} ({{ envInfo.apiBase }})</div>
          <div class="text-surface-600 dark:text-surface-300">Running: {{ envInfo.summary }}</div>
          <div
            *ngIf="envInfo.warning"
            role="alert"
            class="rounded border border-amber-500 bg-amber-100 dark:bg-amber-950 text-amber-900 dark:text-amber-200 p-2">
            <i class="pi pi-exclamation-triangle mr-1"></i>{{ envInfo.warning }}
          </div>
        </div>
        <hr class="border-surface-300 dark:border-surface-700" />
        <div *ngIf="appVersionLoading" class="text-surface-600">Loading version info...</div>
        <div *ngIf="!appVersionLoading && appVersionError" class="text-red-600">{{ appVersionError }}</div>

        <div *ngIf="!appVersionLoading && appVersionInfo" class="space-y-2">
          <div><strong>Release:</strong> {{ appVersionInfo.release }}</div>
          <div><strong>Build:</strong> {{ appVersionInfo.buildVersion }}</div>
          <div><strong>Release Date:</strong> {{ appVersionDisplayBuiltAt }}</div>
          <div *ngIf="appVersionInfo.gitHash"><strong>Git:</strong> {{ appVersionInfo.gitHash }}</div>
          <div><strong>Source:</strong> {{ appVersionInfo.source === 'version.json' ? 'Deployment marker' : 'Local fallback' }}</div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 w-full">
          <p-button [label]="'Switch to ' + dataTarget.other + ' database'" icon="pi pi-database" severity="secondary" [outlined]="true" (onClick)="appInfoDialogVisible = false; dataTarget.requestSwitch()"></p-button>
          <p-button label="Refresh" severity="secondary" (onClick)="refreshAppInfoDialog()"></p-button>
          <p-button label="Close" (onClick)="appInfoDialogVisible = false"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- The Tasks view has its own Select-mode bar (tasks, not notes): see app-task-list. -->
    @if (isSelectMode && selectedView !== 'Tasks') {
        <div class="mx-3 mb-4 flex flex-wrap items-center justify-between
            gap-3 rounded-2xl border border-primary/60 bg-primary/15 
            px-4 py-3 text-sm text-primary-900 shadow-inner">
            <div class="flex flex-wrap items-center gap-2">
                <p-tieredMenu #bulkActionsMenu [model]="bulkActionMenuItems" [popup]="true"
                  appendTo="body"> </p-tieredMenu>
                <button
                type="button"
                class="rounded-full border border-primary/50 px-4 py-1 text-xs 
                    font-semibold tracking-wide text-primary-700 transition hover:bg-white
                    disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent"
                [disabled]="selectedNoteIds.length === 0"
                [title]="selectedNoteIds.length === 0 ? 'Select one or more notes first' : ''"
                (click)="bulkActionsMenu.toggle($event)">
                <span class="flex items-center gap-1">
                    Actions
                    <i class="pi pi-chevron-down text-[10px]"></i>
                </span>
                </button>
                <button type="button"
                class="rounded-full border border-primary/50 px-4 py-1 text-xs
                    font-semibold tracking-wide text-primary-700 transition hover:bg-white"
                  [title]="'Selects all ' + filteredNotes.length + ' notes matching the current search/filter, on every page of the List view'"
                  (click)="selectAllFilteredNotes()">
                  Select all {{ filteredNotes.length | number }} matching {{ filteredNotes.length === 1 ? 'note' : 'notes' }}
                </button>
                <button type="button"
                class="rounded-full border border-primary/50 px-4 py-1 text-xs
                  font-semibold tracking-wide text-primary-700 transition hover:bg-white"
                    (click)="clearSelectedNotes()">
                    Clear Selection
                </button>
                <div class="ml-3">
                    <div class="font-semibold tracking-wide">Select mode active</div>
                    <div class="text-xs text-primary-700">
                        {{ selectedNoteIds.length }} note(s) selected
                    </div>
                </div>
            </div>
            <div class="flex items-center gap-2">
                <button
                type="button"
                class="rounded-full bg-primary px-4 py-1 text-xs 
                    font-semibold tracking-wide text-white shadow hover:bg-primary-600"
                (click)="selectMode()">
                Exit Select Mode
                </button>
            </div>
        </div>
    }

    @if (isSemanticSearchActive && (semanticSearchLoading || semanticSearchError)) {
      <section class="mx-3 mb-4 rounded-xl border border-slate-200 bg-white p-4 space-y-2">
        @if (semanticSearchLoading) {
          <div class="text-sm text-slate-500">Searching...</div>
        }

        @if (!semanticSearchLoading && semanticSearchError) {
          <div class="text-sm text-red-600">{{ semanticSearchError }}</div>
        }
      </section>
    }

    <!-- ── Quick-Access split layout ─────────────────────────────────────── -->
    <div class="home-content-scroll-region flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
    <ng-container *ngIf="!isQaSmallScreen; else qaViewDirect">
      <ng-container *ngIf="!quickAccessCollapsed; else qaCollapsed">
        <p-splitter
          layout="horizontal"
          [panelSizes]="quickAccessSizes"
          [minSizes]="[8, 30]"
          [gutterSize]="5"
          styleClass="h-full w-full !border-0 !shadow-none"
          (onResizeEnd)="onQuickAccessResize($event)">
          <ng-template pTemplate="panel">
            <app-quick-access
              [notes]="allNotes"
              [filteredNotes]="filteredNotes"
              [availableTags]="filterTagCatalog"
              [filter]="filter"
              [isSelectMode]="isSelectMode && selectedView !== 'Tasks'"
              [selectedNoteIds]="selectedNoteIds"
              (selectedNoteIdsChange)="selectedNoteIds = $event"
              (relatedTagSelected)="onQuickAccessRelatedTagSelected($event)"
              (relatedTagRemoved)="onQuickAccessRelatedTagRemoved($event)"
              (relatedTagExcluded)="onQuickAccessRelatedTagExcluded($event)"
              (collapsePanel)="collapseQuickAccess()">
            </app-quick-access>
          </ng-template>
          <ng-template pTemplate="panel">
            <div class="home-view-scroll-region flex flex-col h-full overflow-y-auto">
              <ng-container *ngTemplateOutlet="viewContent"></ng-container>
            </div>
          </ng-template>
        </p-splitter>
      </ng-container>
    </ng-container>

    <ng-template #qaCollapsed>
      <div class="flex min-h-0 h-full">
        <button
          type="button"
          class="qa-expand-btn flex-shrink-0"
          (click)="expandQuickAccess()"
          title="Expand Quick Access">
          <span class="material-icons text-base" aria-hidden="true">chevron_right</span>
        </button>
        <div class="home-view-scroll-region flex-1 min-w-0 overflow-y-auto">
          <ng-container *ngTemplateOutlet="viewContent"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #qaViewDirect>
      <div class="home-view-scroll-region h-full overflow-y-auto">
        <ng-container *ngTemplateOutlet="viewContent"></ng-container>
      </div>
    </ng-template>

    <!-- All view content wrapped in a named template -->
    <ng-template #viewContent>
      @if (selectedView === 'Projects') {
        <app-project-cards
          [notes]="filteredNotes" [projects]="projects" [filter]="filter">
        </app-project-cards>
      }

      @if (selectedView === 'Tags') {
        <app-tag-cards
          [notes]="filteredNotes"
          [tags]="filterTagCatalog"
          [filter]="filter"
          [filterTagIds]="filter.TagIds"
          [isSelectMode]="isSelectMode"
          [(selectedNoteIds)]="selectedNoteIds"
          (clickTagAction)="onTagClicked($event)">
        </app-tag-cards>
      }

      @if (selectedView === 'List') {
        <app-list
          [tags]="filterTagCatalog"
          [spaces]="mySpaces"
          [privateTagIndex]="privateTagIndex"
          [notes]="filteredNotes"
          [filter]="filter"
          [isFiltered]="isFiltered"
          [printFilterSummary]="printFilterSummary"
          [isSelectMode]="isSelectMode"
          [isOnline]="isOnline"
          (noteTagChange)="onNoteTagChange($event)"
          (desktopPagerChange)="listPager = $event"
          (tagCreated)="onTagCreated($event)"
          [(selectedNoteIds)]="selectedNoteIds">
        </app-list>
      }

      @if (selectedView === 'Tasks') {
        <app-task-list
          [notes]="filteredNotes"
          [filter]="filter"
          [tags]="filterTagCatalog"
          [privateTagIndex]="privateTagIndex"
          [spaces]="mySpaces"
          [loading]="!notesLoaded"
          [isSelectMode]="isSelectMode"
          (exitSelectMode)="selectMode()">
        </app-task-list>
      }

      @if (selectedView === 'Calendar') {
        <app-calendar-view
          [notes]="filteredNotes"
          [tags]="filterTagCatalog"
          [privateTagIndex]="privateTagIndex"
          [filter]="filter"
          [initialMonth]="calendarMonthState"
          [initialVisibility]="calendarVisibilityState"
          (monthChanged)="onCalendarMonthChanged($event)"
          (visibilityChanged)="onCalendarVisibilityChanged($event)">
        </app-calendar-view>
      }
    </ng-template>
    <!-- ── end Quick-Access split layout ─────────────────────────────────── -->
    </div>
  </div>

    @if (isSelectMode) {
        <div class="select-mode-overlay pointer-events-none">
            <div class="select-mode-overlay__inner">
            <span class="material-icons text-lg" aria-hidden="true"> bolt </span>
            <span>Select Mode Enabled</span>
            </div>
        </div>
    }

  <!-- Floating mobile search bar. Kept OUTSIDE .home-zoom-layer, as a sibling of the FAB/footer below —
       any position:fixed descendant of that layer would be pinned to ITS (zoom-transformed) box
       instead of the true viewport edge, since a CSS transform on an ancestor creates a new containing
       block for fixed descendants. Desktop is untouched: its search field stays put in app-header's own
       top bar; this bar is sm:hidden, mobile-only.
       On a device with NO bottom safe area (e.g. this simulator), this offset is already at its floor:
       measured against the fixed bottom status bar (.home-footer, kept unchanged — it spans nearly the
       full width, so there's no free space to share a row with), the gap is only ~3px, and going lower
       overlaps that bar's text (confirmed empirically). But on a device WITH a bottom safe area (a
       notched/home-indicator phone), the gap is much larger than that: this bar's offset adds the
       FULL safe-area inset on top of the base 2rem, while the footer's own padding only grows by a
       fraction of it (`* 0.35`, see .home-footer below) — so the gap grows with the inset instead of
       staying constant (confirmed via Emulation.setSafeAreaInsetsOverride: a 34px inset — a common
       real value — produced a 26px gap here, not 3px). Only halving the SAFE-AREA portion (not the
       base 2rem, which has no margin to give on a zero-inset device) closes most of that gap on
       real devices while leaving the zero-inset case untouched (verified: 3px clear either way).
       Narrowed (right reserves the FAB's own width + its right offset + a small gap) so both sit side
       by side without overlapping — no longer necessarily at the same height as the FAB, since this
       offset now shrinks faster than the FAB's as the safe area grows. Borderless (shadow only) — a
       bordered pill read as less polished floating over the list.
       Styled after a native mobile search field (e.g. iOS Contacts): a flat light-grey pill (dark-grey
       in dark mode, not the app's usual white/near-black surface — a search field reads as a distinct
       control, not another content surface), a leading magnifying-glass glyph, and no border anywhere
       in its resting state. Both need `!important` (Tailwind's `!` prefix), not plain utility classes:
       PrimeNG's own `.p-inputtext` rule sets a themed-colour 1px border AND ~12px left/right padding at
       the SAME CSS specificity (one class), and its stylesheet is injected at runtime after the app's
       static CSS, so it otherwise wins the tie. Confirmed both ways before these overrides: a visible
       green 1px border, and (the actual reported bug) the placeholder text starting at PrimeNG's own
       12px padding — well inside the icon's box — because a plain `pl-8` lost the same tie the border
       did. The glyph is `pointer-events-none` and absolutely positioned OVER the
       input's own left padding rather than a separate flex item/button, so it's purely decorative —
       tapping that area focuses the input underneath, exactly like a native field's icon. The
       search-text-active red ring (used elsewhere, e.g. the desktop search field) is deliberately not
       used here, only a standard focus-visible ring — a permanent colour ring would itself read as a
       border once text is entered, contradicting "no border". -->
  <div
    class="sm:hidden fixed z-40 left-3 flex items-center gap-0.5 rounded-full bg-gray-100 dark:bg-gray-800 shadow-sm px-1 py-1"
    style="right: 6.5rem; bottom: calc(2rem + env(safe-area-inset-bottom) * 0.5)">
    <div class="relative min-w-0 flex-1">
      <i class="pi pi-search pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-gray-500 dark:text-gray-400" aria-hidden="true"></i>
      <input
        pInputText
        #MobileSearchField
        class="min-h-11 w-full rounded-full !border-0 !bg-transparent py-0 !pl-8 !pr-1 text-color focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
        type="text"
        placeholder="Search…"
        [(ngModel)]="header.filter.SearchString"
        (input)="header.onSearch(MobileSearchField.value)"
        aria-label="Search notes" />
    </div>
    <button
      type="button"
      class="flex-shrink-0 inline-flex items-center justify-center min-h-11 min-w-11 rounded-full border-0 bg-transparent text-gray-500 dark:text-gray-300 hover:text-gray-700"
      [ngClass]="{ '!text-red-500': header.isSearchTypeActive }"
      (click)="header.toggleMobileSearchTypeMenu($event)"
      aria-label="Choose search type">
      <i class="pi pi-sliders-h"></i>
    </button>
    <button
      type="button"
      class="flex-shrink-0 inline-flex items-center justify-center min-h-11 min-w-11 rounded-full border-0 bg-transparent hover:text-gray-700"
      (click)="header.clearSearchField()"
      aria-label="Clear search">
      <i class="pi pi-times text-red-500"></i>
    </button>
  </div>

  <!-- Floating Action Button. bottom matches the mobile search field's own offset exactly (see
       above) so their bottom edges align, per request. -->
  <div class="fixed z-50 home-fab"
        style="right: 1.5rem; bottom: calc(2rem + env(safe-area-inset-bottom) * 0.5)">
    <p-menu #templateFabMenu [model]="templateMenuItems" [popup]="true" appendTo="body"></p-menu>
    <div class="home-fab-actions">
      <p-button
        type="button"
        icon="pi pi-plus"
        styleClass="fab-main-button"
        (onClick)="createNewNote()">
      </p-button>
      <p-button
        type="button"
        icon="pi pi-chevron-down"
        styleClass="fab-menu-button"
        aria-label="Create from template"
        (onClick)="onTemplateMenuOpened(); templateFabMenu.toggle($event)">
      </p-button>
    </div>
  </div>

  <!-- Create from Template Dialog -->
  <p-dialog
    header="Create from Template"
    [(visible)]="templateDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '560px', maxWidth: '95vw' }"
    appendTo="body">

    @if (templatesLoading) {
    <div class="flex items-center gap-2 text-sm text-surface-600">
        <i class="pi pi-spin pi-spinner"></i>
        Loading templates...
    </div>
    }

    @if (!templatesLoading && templateLoadError) {
    <div class="text-sm text-red-600">
        {{ templateLoadError }}
    </div>
    }

    @if (!templatesLoading && !templateLoadError && templates.length === 0) {
    <div class="text-sm text-surface-600">
        No templates found. Save a note as a template to get started.
    </div>
    }

    @if (!templatesLoading && templates.length) {
    <div class="flex flex-col gap-2">
        <div
        *ngFor="let template of templates"
        class="flex items-center justify-between gap-3 rounded-lg border 
            border-surface-200 px-3 py-2">
        <div class="min-w-0">
            <div class="font-semibold truncate">
            {{ template.templateName || template.Title || 'Untitled template' }}
            </div>
            <div class="text-xs text-surface-500">
            {{ stripHtml(template.DescriptionHtml || '').slice(0, 80) }}
            </div>
        </div>
        <p-button label="Use" icon="pi pi-arrow-right" 
            (onClick)="createNoteFromTemplate(template)"></p-button>
        </div>
    </div>
    }

    <ng-template pTemplate="footer">
    <p-button
        label="Close"
        severity="secondary"
        icon="pi pi-times"
        (onClick)="templateDialogVisible = false"></p-button>
    </ng-template>
</p-dialog>

  <!-- Synch Status Dialog -->
  <p-dialog
    header="Synch Status Dialog"
    [(visible)]="showSyncDialog"
    [modal]="false"
    [closable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    [style]="{ width: '64rem', maxWidth: '95vw', height: '550px' }"
    [draggable]="true"
    [resizable]="true"
    appendTo="body"
    [baseZIndex]="10000"
    styleClass="sync-dialog"
    (onHide)="onSyncDialogHide()">
    <!-- Body: status + messages -->
    <div class="space-y-3 h-full flex flex-col">
      <div class="grid grid-cols-2 gap-4">
        <div class="flex items-center gap-2 min-w-0">
          <span class="font-medium">CouchDB:</span>
          <span
            [ngClass]="{
              'text-green-600': syncStatus.couchdb === 'ok',
              'text-yellow-600': syncStatus.couchdb === 'syncing',
              'text-red-600': syncStatus.couchdb === 'error' || 
                  syncStatus.couchdb === 'offline'
            }">
            {{ syncStatus.couchdb === 'offline' ? (connectivity.level === 'server-unreachable' ? 'Server Unreachable' : 'Offline') : (syncStatus.couchdb | titlecase) }}
          </span>
        </div>

        <div class="flex items-center gap-2 min-w-0">
          <span class="font-medium">IndexedDB:</span>
          <span
            [ngClass]="{
              'text-green-600': syncStatus.indexeddb === 'ok',
              'text-yellow-600': syncStatus.indexeddb === 'syncing',
              'text-red-600': syncStatus.indexeddb === 'error' || 
              syncStatus.indexeddb === 'offline'
            }">
            {{ syncStatus.indexeddb | titlecase }}
          </span>
        </div>
      </div>

      @if (syncStatus.lastSynced) {
        <div class="text-xs text-surface-500 dark:text-surface-400">
          Last sync: {{ syncStatus.lastSynced | date : 'short' }}
        </div>
      }
      <!-- Messages area -->
      <div #syncLogContainer class="border rounded p-2 flex-1 min-h-40 overflow-auto 
            bg-surface-50 dark:bg-surface-800">
            <div class="whitespace-pre-wrap text-sm" 
                *ngFor="let m of (synchLog$ | async) ?? []; trackBy: trackByIndex">
                • {{ m }}
            </div>

        @if (!(synchLog$ | async)?.length) {
          <div class="text-sm italic text-surface-500 dark:text-surface-400">
            No messages yet.
          </div>
        }
      </div>
    </div>

    <!-- Synch Status Footer -->
    <ng-template pTemplate="footer">
      <div class="sync-dialog-footer flex justify-end gap-2">
        <p-button
          label="Info"
          icon="pi pi-info-circle"
          styleClass="sync-dialog-btn"
          severity="secondary"
          (onClick)="getDbInfos()"></p-button>
        <p-button
          label="Synch-List"
          icon="pi pi-list"
          styleClass="p-button-info sync-dialog-btn"
          routerLink="/sync-list"></p-button>
        <p-button
          label="Synch Now"
          icon="pi pi-sync"
          styleClass="sync-dialog-btn"
          [loading]="isSyncing"
          (onClick)="synchNow()"></p-button>
        <p-button
          label="Force Baseline Sync"
          icon="pi pi-exclamation-triangle"
          styleClass="sync-dialog-btn"
          severity="danger"
          (onClick)="forceBaselineConfirmed()"></p-button>
        <p-button
          label="Clear Log"
          icon="pi pi-trash"
          styleClass="sync-dialog-btn"
          severity="secondary"
          (onClick)="clearSynchLog()"></p-button>
        <p-button
          label="Close"
          severity="secondary"
          icon="pi pi-times"
          styleClass="sync-dialog-btn sync-dialog-btn--full"
          (onClick)="closeSyncDialog()"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Bottom of the page: the List's page navigation bar (desktop / iPad, handed over by ListComponent) right
       on top of the footer bar — one fixed stack, so there is never a gap between them. The bar runs from the
       left edge of the page and stops before the "+" button, which stays where it is. -->
  <div #bottomStack class="home-bottom-stack">
  @if (showListPager) {
    <div class="home-list-pager">
      <ng-container *ngTemplateOutlet="listPager"></ng-container>
    </div>
  }
  <!-- FOOTER BAR -->
  <div class="home-footer">
    <div class="flex gap-2 items-center">
      <p-button #zoomTrigger text class="home-icon-button" (click)="toggleZoomPanel($event)">
        <ng-template pTemplate="icon">
          <span class="material-symbols-outlined">zoom_in</span>
        </ng-template>
      </p-button>
    </div>
    <!-- Phones: a 3-column grid (see .home-footer in the SCSS) — this wrapper dissolves (display: contents)
         so the doc count + info button sit exactly centred, with the zoom and connectivity groups either side. -->
    <div class="home-footer-right flex gap-4 items-center">
      <div class="home-footer-filter-status flex items-center gap-1.5">
        <!-- Desktop: unchanged wording (a "Filtered"/"Unfiltered" label plus a neutral-coloured count). -->
        <span class="hidden sm:inline">{{ isFiltered ? 'Filtered' : 'Unfiltered' }}</span>
        <span class="hidden sm:inline" aria-hidden="true">|</span>
        <span class="hidden sm:inline">{{ displayedNotesCount }} record{{ displayedNotesCount !== 1 ? 's' : '' }}</span>
        <!-- Mobile: no "Filtered"/"Unfiltered" label — the count itself carries that meaning via
             colour (green = no filter active, orange = a filter is applied), and "docs" replaces
             "records". -->
        <span
          class="sm:hidden font-medium"
          [ngClass]="isFiltered ? 'text-orange-500' : 'text-green-600'">{{ displayedNotesCount }} doc{{ displayedNotesCount !== 1 ? 's' : '' }}</span>
        <button
          type="button"
          class="home-footer-filter-info-button"
          aria-label="Show filter details"
          title="Show active filter details"
          (click)="openFilterInfoDialog()">
          i
        </button>
      </div>
      <div class="home-footer-connectivity flex items-center gap-2">
        <span
          class="home-footer-online-indicator cursor-pointer"
          role="button"
          tabindex="0"
          [ngClass]="{ 'online': connectivity.fullyOnline, 'offline': !connectivity.fullyOnline }"
          [attr.aria-label]="connectivity.label"
          [title]="connectivity.label"
          (click)="connectivityPopover.toggle($event)"
          (keydown.enter)="connectivityPopover.toggle($event)">
          <span class="material-symbols-outlined home-footer-status-icon"
            [ngClass]="connectivity.fullyOnline ? 'home-footer-status-icon--online' : 'home-footer-status-icon--offline'">{{ connectivity.icon }}</span>
        </span>
        <div class="home-footer-status">{{ globalStatusMessage }}</div>
      </div>
    </div>
  </div>
  </div>

  <p-popover #connectivityPopover [dismissable]="true" appendTo="body" styleClass="connectivity-status-popover">
    <div class="connectivity-status-popover__content">{{ connectivityPopoverMessage }}</div>
  </p-popover>

  <p-dialog
    header="Current Filter Details"
    [(visible)]="filterInfoDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '44rem', maxWidth: '96vw' }"
    appendTo="body"
    styleClass="filter-info-dialog">
    <div class="filter-info-dialog__summary">
      <div><strong>State:</strong> {{ isFiltered ? 'Filtered' : 'Unfiltered' }}</div>
      <div><strong>Hit Count:</strong> {{ displayedNotesCount }}</div>
      <div><strong>Total Notes:</strong> {{ allNotes.length }}</div>
      <div><strong>Current View:</strong> {{ selectedView }}</div>
    </div>

    <div class="filter-info-dialog__human-wrap">
      <div class="filter-info-dialog__label"><strong>Active filters:</strong></div>
      <div class="filter-info-dialog__human-content">
        <div *ngIf="currentFilterHumanReadable.length === 0" class="filter-info-dialog__empty">
          No active filters.
        </div>
        <div *ngIf="currentFilterHumanReadable.length > 0" class="filter-info-dialog__human-list">
          <div class="filter-info-dialog__human-row" *ngFor="let row of currentFilterHumanReadable">
            <div class="filter-info-dialog__human-label">{{ row.label }}</div>
            <div class="filter-info-dialog__human-value">{{ row.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="JSON"
        icon="pi pi-code"
        severity="contrast"
        outlined="true"
        (onClick)="openFilterInfoJsonDialog()">
      </p-button>
      <p-button
        label="Close"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="filterInfoDialogVisible = false">
      </p-button>
    </ng-template>
  </p-dialog>

  <p-dialog
    header="Current Filter JSON"
    [(visible)]="filterInfoJsonDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '44rem', maxWidth: '96vw' }"
    appendTo="body"
    styleClass="filter-info-dialog">
    <div class="filter-info-dialog__json-wrap">
      <div class="filter-info-dialog__label">Active Filter (JSON)</div>
      <pre class="filter-info-dialog__json">{{ currentFilterDisplay }}</pre>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        label="Close"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="filterInfoJsonDialogVisible = false">
      </p-button>
    </ng-template>
  </p-dialog>

  <!-- Zoom Panel -->
  <div
    #zoomPanel
    *ngIf="showZoomPanel"
    class="home-zoom-panel"
    (click)="$event.stopPropagation()">
    <div class="home-zoom-panel__header">
      <span class="home-zoom-panel__title">System Zoom</span>
      <button class="home-zoom-panel__close" type="button" (click)="showZoomPanel = false">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
    <div class="home-zoom-panel__body">
      <p-slider
        [(ngModel)]="systemZoomFactor"
        [min]="50"
        [max]="400"
        [step]="1"
        (onChange)="onSystemZoomChange($event)"
        (onSlideEnd)="persistSystemZoom()">
      </p-slider>
      <div class="home-zoom-panel__value">{{ systemZoomFactor }}%</div>
    </div>
  </div>
</div>
